import { SampleTypeEnum } from 'src/app/enums/sampleType.enum';

export interface SampleValidationRule {
    maxCalDriftPercent?: number | null;
    maxNoiseDriftDb?: number | null;
    minRunTimeSeconds?: number | null;
    requiredFields?: string[] | null;
}

export interface SampleValidationConfig {
    sampleTypeRules?: { [key in SampleTypeEnum]?: SampleValidationRule } | null;
}

/**
 * Reads the validation rule for a single sample type from a loaded config.
 * Handles both the canonical numeric key ("0") and the legacy string enum-name
 * key ("Air") that older builds persisted (see DASH-2714), preferring the numeric one.
 */
export function getSampleTypeRule(
    config: SampleValidationConfig | null | undefined,
    sampleType: SampleTypeEnum | null | undefined
): SampleValidationRule | undefined {
    const rules = config?.sampleTypeRules as { [key: string]: SampleValidationRule | undefined } | null | undefined;
    if (!rules || sampleType == null) {
        return undefined;
    }
    const numericRule = rules[sampleType];
    if (numericRule != null) {
        return numericRule;
    }
    const name = SampleTypeEnum[sampleType];
    return name ? rules[name] : undefined;
}

export interface SampleRequiredFieldOption {
    value: string;
    label: string;
}

export interface SampleValidationRuleSectionErrors {
    maxCalDriftPercent?: string | null;
    maxNoiseDriftDb?: string | null;
    minRunTimeMinutes?: string | null;
}

export interface SampleValidationRuleSection {
    sampleType: SampleTypeEnum;
    label: string;
    usesNoiseDrift: boolean;
    maxCalDriftPercent: number | null;
    maxNoiseDriftDb: number | null;
    minRunTimeMinutes: number | null;
    requiredFields: string[];
    isCustom: boolean;
    runTimeSecondsHelper: string;
    errors: SampleValidationRuleSectionErrors;
}
